export const isLoggedIn = state => state.currentUser.loggedIn;
export const isPublic = state => state.currentUser.privacyStatus === 'PUBLIC';
